import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserAvatar } from '../../../components/UserAvatar';
import { AccountInfoContext } from '../../../contexts/AccountInfoContext';
import { resources } from '../../../resources/resources';
import { MyAccountAuthentication } from './Authentication';
import { MyAccountChangePassword } from './ChangePassword';
import { MyAccountDetails } from './Details';

export const MyAccountDetailsPage = () => {
  return <MyAccount initialTab={MyAccountTabTypes.Details} />;
};

export const MyAccountChangePasswordPage = () => {
  return <MyAccount initialTab={MyAccountTabTypes.ChangePassword} />;
};

export const MyAccountAuthenticationPage = () => {
  return <MyAccount initialTab={MyAccountTabTypes.Authentication} />;
};

interface MyAccountProps {
  initialTab: MyAccountTabTypes;
}

enum MyAccountTabTypes {
  Details = 1,
  ChangePassword = 2,
  Authentication = 3,
}

const MyAccount = (props: MyAccountProps) => {
  const { t: translate } = useTranslation();
  const { accountInfo } = useContext(AccountInfoContext);
  const [activeTab, setActiveTab] = useState<MyAccountTabTypes>(
    props.initialTab,
  );

  return (
    <>
      <h1>{translate(resources.accounts.myAccount.title)}</h1>

      <div className="m-panel">
        <div className="m-my-account-username">
          <UserAvatar
            color1={accountInfo.avatarColor1}
            color2={accountInfo.avatarColor2}
            fontColor={accountInfo.avatarFontColor}
            initials={accountInfo.initials}
          />
          <h2>{accountInfo.fullName}</h2>
        </div>
        <MyAccountTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        {activeTab === MyAccountTabTypes.Details && <MyAccountDetails />}
        {activeTab === MyAccountTabTypes.ChangePassword && (
          <MyAccountChangePassword />
        )}
        {activeTab === MyAccountTabTypes.Authentication && (
          <MyAccountAuthentication />
        )}
      </div>
    </>
  );
};

const MyAccountTabs = (props: {
  activeTab: MyAccountTabTypes;
  setActiveTab: (tab: MyAccountTabTypes) => void;
}) => {
  const { activeTab, setActiveTab } = props;
  const { t: translate } = useTranslation();

  return (
    <ul className="merchants-panel-tabs">
      <li
        onClick={() => setActiveTab(MyAccountTabTypes.Details)}
        className={
          activeTab === MyAccountTabTypes.Details ? 'merchants-tab-active' : ''
        }
      >
        {translate(resources.accounts.myAccount.tabs.details)}
      </li>
      <li
        onClick={() => setActiveTab(MyAccountTabTypes.ChangePassword)}
        className={
          activeTab === MyAccountTabTypes.ChangePassword
            ? 'merchants-tab-active'
            : ''
        }
      >
        {translate(resources.accounts.myAccount.tabs.changePassword)}
      </li>
      <li
        onClick={() => setActiveTab(MyAccountTabTypes.Authentication)}
        className={
          activeTab === MyAccountTabTypes.Authentication
            ? 'merchants-tab-active'
            : ''
        }
      >
        {translate(resources.accounts.myAccount.tabs.authentication)}
      </li>
    </ul>
  );
};
